import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import useAvailibleMenu from "./useAvailibleMenu";
import MenuType from "./menuTypeConst";

const useSensolusMenu = (loginInfo) => {
  const language = useSelector((state) => state.language);

  const routes = useMemo(() => {
    const { features, permissionsMap } = loginInfo;

    return [
      {
        collapse: true,
        name: language.trackers_and_sensors_key,
        state: "openTrackersSensors",
        icon: (
          <span className="tracker-profile-admin-menu-icon menu-icon"></span>
        ),
        views: [
          {
            view: permissionsMap["MENU_ADMIN_TRACKERS"],
            to: "/trackers",
            layout: "",
            name: language.sidebar_admin_trackers_key,
            subPages: ["/import_tracker_settings"],
          },
          {
            view:
              features["bulk_operations"] &&
              permissionsMap["MENU_ADMIN_BULK_OPERATION"],
            to: "/bulk_manage",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_BULK_OPERATION_description_key,
            subPages: ["/bulk_operations", "/bulk_results_detail_system"],
          },
          {
            view: permissionsMap["MENU_ADMIN_TRACKER_PRODUCT"],
            to: "/tracker_product",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_TRACKER_PRODUCT_description_key,
            subPages: ["/tracker_product_detail"],
          },
          {
            view: permissionsMap["MENU_ADMIN_PRODUCT_AUTO_UPGRADE"],
            to: "/product_auto_upgrade",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_PRODUCT_AUTO_UPGRADE_description_key,
            subPages: ["/product_auto_upgrade_detail"],
          },
          {
            view: permissionsMap["MENU_ADMIN_PRODUCT_REGEXP_FILTER"],
            to: "/product_regexp_filter",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_PRODUCT_REGEXP_FILTER_description_key,
            subPages: ["/product_regexp_filter_detail"],
          },
          {
            view: permissionsMap["MENU_ADMIN_USAGE_PROFILE"],
            to: "/device_usage_profile",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_USAGE_PROFILE_description_key,
            subPages: ["/device_usage_profile_manage"],
          },
          {
            view: permissionsMap["MENU_ADMIN_BLE_SENSOR"],
            to: "/ble_sensors",
            layout: "",
            name: language.UserPermission_MENU_ADMIN_BLE_SENSOR_description_key,
          },
        ],
      },
      {
        collapse: true,
        name: language.location_key,
        state: "openOrgSetting",
        icon: <span className="location-stop-icon menu-icon"></span>,
        views: [
          {
            view:
              features["loc_beacon"] &&
              permissionsMap["MENU_ADMIN_GEOLAYER_GENERATOR"],
            to: "/geolayer_generator",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_GEOLAYER_GENERATOR_description_key,
            subPages: ["/geolayer_generator_manage"],
          },
          {
            view:
              features["loc_beacon"] &&
              permissionsMap["MENU_ADMIN_INFRASTRUCTURE"],
            to: "/infrastructures",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_INFRASTRUCTURE_description_key,
            subPages: ["/import_infrastructure_settings"],
          },
          {
            view: permissionsMap["MENU_ADMIN_PRIVATE_CELLULAR"],
            to: `/private_cellular_all`,
            layout: "",
            name: language.UserPermissionCategory_PRIVATE_CELLULAR_title_key,
          },
          {
            view: permissionsMap["MENU_ADMIN_CELL_TOWER_TROUBLESHOOTING"],
            to: `/wifi_cellular_mismatch`,
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_CELL_TOWER_TROUBLESHOOTING_description_key,
          },
        ],
      },
      {
        collapse: true,
        name: language.organizations_key,
        state: "openOrgSetting",
        icon: <span className="org-admin-menu-icon menu-icon"></span>,
        views: [
          {
            view: permissionsMap["MENU_ADMIN_PARTNERS"],
            to: "/partners",
            layout: "",
            name: language.UserPermission_MENU_ADMIN_PARTNERS_description_key,
            subPages: ["/partners_update", "/partners_create"],
          },
          {
            view: permissionsMap["MENU_ADMIN_ORGANIZATION_LIST"],
            to: `/organization`,
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_ORGANIZATION_LIST_description_key,
          },
          {
            view:
              features["demo_environment"] && permissionsMap["MENU_ADMIN_DEMO"],
            to: "/org_demo",
            layout: "",
            name: language.UserPermission_MENU_ADMIN_DEMO_description_key,
            subPages: ["/org_demo_manage"],
          },
          {
            view: permissionsMap["MENU_ADMIN_INTERNAL_PLATFORM_PLAN"],
            to: `/internal_plans`,
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_INTERNAL_PLATFORM_PLAN_description_key,
          },
        ],
      },
      {
        collapse: true,
        name: language.access_management_key,
        state: "openParnerOrg",
        icon: <span className="access-icon menu-icon"></span>,
        views: [
          {
            view:
              features["user_profile"] &&
              permissionsMap["MENU_ADMIN_USER_ROLE"],
            to: "/role_manager",
            layout: "",
            name: language.UserPermission_MENU_ADMIN_USER_ROLE_description_key,
            subPages: ["/role_manager_update"],
          },
          {
            view: permissionsMap["OAUTH2_CLIENT_VIEW"],
            to: "/oauth2_registered_client",
            layout: "",
            name: language.oauth2_client_management_key,
            subPages: [
              "/oauth2_registered_client_update",
              "/oauth2_registered_client_create",
            ],
          },
        ],
      },
      {
        collapse: true,
        name: language.organisation_billing_key,
        state: "openInsights",
        icon: <span className="invoicing-icon menu-icon"></span>,
        views: [
          {
            view: permissionsMap["MENU_ADMIN_INVOICING_OPERATIONS"],
            to: "/invoicing_operations",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_INVOICING_OPERATIONS_description_key,
            subPages: ["/invoicing_operations_detail"],
          },
          {
            view: permissionsMap["MENU_ADMIN_INVOICES"],
            to: "/invoices",
            layout: "",
            name: language.UserPermission_MENU_ADMIN_INVOICES_description_key,
            subPages: ["/invoices_detail"],
          },
          {
            view: permissionsMap["MENU_ADMIN_RENEWAL_FORECASTS"],
            to: "/quotation",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_RENEWAL_FORECASTS_description_key,
            subPages: ["/quotation_detail"],
          },
          {
            view: permissionsMap["MENU_ADMIN_QUOTES"],
            to: "/quotes",
            layout: "",
            name: language.quotes_key,
            subPages: ["/quote_detail"],
          },
          {
            view: permissionsMap["MENU_ADMIN_PRICELIST"],
            to: `/price_lists`,
            layout: "",
            name: language.price_list_key,
            subPages: ["/price_list_update", "/price_list_items"],
          },
          {
            view: permissionsMap["MENU_ADMIN_PRICE_BOOKS"],
            to: `/pricebook`,
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_PRICE_BOOKS_description_key,
            subPages: ["/pricebook_update", "/pricebook_increase"],
          },
          {
            view: permissionsMap["MENU_ADMIN_PRICE_BOOKS"],
            to: `/customer`,
            layout: "",
            name: language.customers_key,
            subPages: ["/customer_detail"],
          },
          {
            view: permissionsMap["SYSTEM_ADMIN_VIEW"],
            to: `/consolidated_customer`,
            layout: "",
            name: language.consolidated_customers_key,
            subPages: ["/consolidated_customer_update"],
          },
        ],
      },
      {
        collapse: true,
        name: language.salesforce_key,
        state: "openSalesforce",
        icon: <span className="salesforce-icon menu-icon"></span>,
        views: [
          {
            view: permissionsMap["MENU_ADMIN_SALESFORCE_ACCOUNT"],
            to: "/salesforce_account",
            layout: "",
            name: language.accounts_key,
          },
          {
            view: permissionsMap["MENU_ADMIN_SALESFORCE_CONTACT"],
            to: "/salesforce_contact",
            layout: "",
            name: language.contacts_key,
          },
          {
            view: permissionsMap["MENU_ADMIN_SALESFORCE_LEAD"],
            to: "/salesforce_lead",
            layout: "",
            name: language.leads_key,
          },
          {
            view: permissionsMap["MENU_ADMIN_SALESFORCE_OPPORTUNITY"],
            to: "/salesforce_opportunity",
            layout: "",
            name: language.opportunities_key,
            subPages: ["/salesforce_opportunity_line_items"],
          },
          {
            view: permissionsMap["MENU_ADMIN_SALESFORCE_QUOTE"],
            to: "/salesforce_quote",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_SALESFORCE_QUOTE_description_key,
          },
          {
            view: permissionsMap["MENU_ADMIN_SALESFORCE_CHANNEL_PARTNER"],
            to: "/salesforce_channel_partner",
            layout: "",
            name: language.channel_partner_key,
          },
          {
            view: permissionsMap["MENU_ADMIN_SALESFORCE_USER"],
            to: "/salesforce_user",
            layout: "",
            name: language.UserPermission_MENU_ADMIN_USERS_description_key,
          },
        ],
      },
      {
        collapse: true,
        name: language.impartner_key,
        state: "openImpartner",
        icon: <span className="partner-admin-menu-icon menu-icon"></span>,
        views: [
          {
            view: permissionsMap["MENU_ADMIN_IMPARTNER_ACCOUNT"],
            to: "/impartner_account",
            layout: "",
            name: language.accounts_key,
          },
          {
            view: permissionsMap["MENU_ADMIN_IMPARTNER_CHANNEL_PARTNER"],
            to: "/impartner_channel_partner",
            layout: "",
            name: language.channel_partner_key,
          },
          {
            view: permissionsMap["MENU_ADMIN_IMPARTNER_USER"],
            to: "/impartner_user",
            layout: "",
            name: language.impartner_user_key,
          },
        ],
      },
      {
        collapse: true,
        name: language.legal,
        state: "openLegal",
        icon: <span className="legal-icon menu-icon"></span>,
        views: [
          {
            view: permissionsMap["MENU_ADMIN_LEGAL_DOCUMENTS"],
            to: "/legal_document",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_LEGAL_DOCUMENTS_description_key,
            subPages: [
              "/legal_document_import",
              "/legal_document_send",
              "/legal_document_view",
            ],
          },
          {
            view: permissionsMap["MENU_ADMIN_LEGAL_TEMPLATE"],
            to: "/legal_document_template",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_LEGAL_TEMPLATE_description_key,
            subPages: ["/legal_document_template_manage"],
          },
        ],
      },
      {
        collapse: true,
        name: language.customization_key,
        state: "opencustomization",
        icon: <span className="ui-custom-icon menu-icon"></span>,
        views: [
          {
            view:
              features["image_library"] &&
              permissionsMap["MENU_ADMIN_IMAGE_LIBRARY"],
            to: "/image_library_all",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_IMAGE_LIBRARY_description_key,
            subPages: ["/image_library_manage"],
          },
        ],
      },
      {
        collapse: true,
        name: language.sidebar_support_key,
        state: "openInsights",
        icon: <span className="support-icon menu-icon"></span>,
        views: [
          {
            view: permissionsMap["SYSTEM_ADMIN_VIEW"],
            to: "/failed_trackers",
            layout: "",
            name: language.failed_trackers,
          },
          {
            view: permissionsMap["SYSTEM_ADMIN_VIEW"],
            to: "/manufacturing",
            layout: "",
            name: language.v42_manufacturing_key,
            subPages: ["/manufacturing_order_detail"],
          },
          {
            view: permissionsMap["MENU_ADMIN_STOCK"],
            to: "/stock",
            layout: "",
            name: language.UserPermission_MENU_ADMIN_STOCK_description_key,
            subPages: ["/stock_update"],
          },
          {
            view: permissionsMap["MENU_ADMIN_RMA_DECLARATION"],
            to: `/rma_declaration`,
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_RMA_DECLARATION_description_key,
            subPages: ["/rma_declaration_manage"],
          },
        ],
      },
      {
        collapse: true,
        name: language.communication_key,
        state: "openInsights",
        icon: <span className="communication-icon menu-icon"></span>,
        views: [
          {
            view: permissionsMap["MENU_ADMIN_SIGFOX_ACCOUNT"],
            to: "/sigfox_account",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_SIGFOX_ACCOUNT_description_key,
            subPages: [
              "/sigfox_account_update",
              "/sigfox_account_device_type_info",
            ],
          },
          {
            view: permissionsMap["MENU_ADMIN_CELLULAR_ACCOUNT"],
            to: "/cellular_account",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_CELLULAR_ACCOUNT_description_key,
            subPages: ["/cellular_account_manage"],
          },
          {
            view: permissionsMap["MENU_ADMIN_CELLULAR_SIM"],
            to: "/cellular_sim",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_CELLULAR_SIM_description_key,
            subPages: ["/cellular_sim_manage"],
          },
        ],
      },
      {
        collapse: true,
        name: language.platform_notifications_key,
        state: "openLocation",
        icon: <span className="notification-icon menu-icon"></span>,
        views: [
          {
            view: permissionsMap["MENU_ADMIN_NOTIFICATION"],
            to: "/notification",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_NOTIFICATION_description_key,
            subPages: ["/notification_update"],
          },
          {
            view: permissionsMap["MENU_ADMIN_INTEGRATED_HELP"],
            to: "/integrated_help",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_INTEGRATED_HELP_description_key,
            subPages: ["/integrated_help_update"],
          },
        ],
      },
      {
        collapse: true,
        name: language.api_key,
        state: "openLocation",
        icon: <span className="api-icon menu-icon"></span>,
        views: [
          {
            view: permissionsMap["MENU_ADMIN_API_ACCESS"],
            to: "/api-access",
            layout: "",
            name: language.UserPermission_MENU_ADMIN_API_ACCESS_description_key,
          },
          {
            view: permissionsMap["MENU_ADMIN_INTERNAL_API"],
            to: "/internal-api",
            layout: "",
            name:
              language.UserPermission_MENU_ADMIN_INTERNAL_API_description_key,
          },
          {
            view: permissionsMap["MENU_ADMIN_AI_PROMPTS"],
            to: "/ai-prompts",
            layout: "",
            name: language.manage_ai_prompts_key,
          },
          {
            view: permissionsMap["MENU_ADMIN_AI_CHATS"],
            to: "/ai-chats",
            layout: "",
            name: language.manage_ai_chats_key,
            subPages: ["/ai-chat-view"],
          },
        ],
      },
    ];
  }, [loginInfo, language]);

  const [data, setData] = useState({
    type: MenuType.ALL,
    loading: true,
    routes: [],
    availableMenuPaths: {},
    allPaths: {},
    defaultPath: "/organization",
  });

  const availibleMenuData = useAvailibleMenu(routes, "/organization");

  useEffect(() => {
    setData({ ...data, ...availibleMenuData, loading: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availibleMenuData]);

  return data;
};

export default useSensolusMenu;
